package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_price_data_di_PriceModule : Module get() = module {
	single() { _ -> com.essntl.features.price.data.repository.PriceRepositoryImpl(proposalServicePriceSupabaseDataSource=get()) } bind(com.essntl.features.price.domain.repository.PriceRepository::class)
	single() { _ -> com.essntl.features.price.data.supabase.proposalserviceprice.ProposalServicePriceSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.price.data.supabase.proposalserviceprice.ProposalServicePriceSupabaseDataSource::class)
}
public val com.essntl.features.price.data.di.PriceModule.module : org.koin.core.module.Module get() = com_essntl_features_price_data_di_PriceModule
